import { ComponentType } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from './providers';

export const renderApp = (App: ComponentType) => {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Root element was not found');
  }

  createRoot(container).render(
    <AppProviders>
      <App />
    </AppProviders>,
  );
};
